import classNames from 'classnames';
import {FormTextArea} from '@homeaway/react-form-components';
import React from 'react';
import {withTranslationsAsProps} from '../translations';
import './form-char-counter.less';

export const getCount = (value = '', max = 0) => {
    if (typeof value !== 'string') {
        return max;
    }
    return max - value.length;
};

export const isOverLimit = (value = '', max = 0) => {
    const count = getCount(value, max);
    return count < 0;
};

export function FormCharCounter({
    errorMsg,
    helpText,
    langOverCharLimit,
    maxLength,
    value = '',
    ...rest
}) {
    const count = getCount(value, maxLength);
    const isOver = isOverLimit(value, maxLength);
    const langError = errorMsg || (isOver ? langOverCharLimit : null);
    const containerClass = classNames({
        'form-char-counter': true,
        'has-error': !!errorMsg,
        'has-help': !!helpText,
        'has-limit-error': !!isOver
    });
    const counterClass = classNames({
        'form-char-counter__count': true,
        'has-limit-error': !!isOver,
        'help-block': true
    });

    return (
        <div className={containerClass}>
            <FormTextArea
                helpText={helpText}
                errorMsg={langError}
                value={value}
                {...rest}
            />
            <span className={counterClass}>{count}</span>
        </div>
    );
}

export default withTranslationsAsProps({
    'tripboards.over.char.limit': 'langOverCharLimit'
})(FormCharCounter);


// WEBPACK FOOTER //
// ./src/universal/components/form-char-counter/form-char-counter.js